import { FilterIcon } from "lucide-react"

export function ActiveFilterIcon() {
  return <FilterIcon className="bg-green-400 w-6 h-6 px-1 ml-1 rounded-md" />
}
